module.exports = __webpack_public_path__ + "img/text.02f47d79.png";